import { http, HttpResponse } from 'msw';
import { auditLogsMocks } from '../mocks';

export const auditLogsHandler = http.get('*/auditLogs?*', () =>
  HttpResponse.json(auditLogsMocks.auditLogs)
);
